<nav class="navbar navbar2">
  <div class="navbar-header customHeaderNavHome">
    <button type="button" class="navbar-toggle" (click)="toggleNavbar()">
      <span class="sr-only">Toggle navigation</span>
      <span class="icon-bar"></span>
      <span class="icon-bar"></span>
      <span class="icon-bar"></span>
    </button>
    <a class="navbar-brand" href="#" routerLink="" routerLinkActive="active" (click)="toggleHighlight(1,'home');"
      (click)="collapseNavbar()"><img src="assets/images/ppm/logo_allianz.png" alt="aAZy Pension" width="82%" />
    </a>
  </div>
  <div class="navbar-collapse" id="myNavbar2">
    <ul class="nav navbar-nav" *ngFor="let link of authenticatedMenus;let i = index;">
      <li (click)="toggleMenu1($event,link.subMenuCount,link.title)" uib-dropdown class="dropdown pointer">
        <a *ngIf="link.title == 'Home'" routerLink="" routerLinkActive="active" (click)="collapseNavbar()">
          <span [ngClass]="{ activeSpan: isActive('') }">{{'global.menu.home' | translate}}
          </span>
        </a>
        <a *ngIf="link.title == 'Balance'" routerLink="balance" routerLinkActive="active" (click)="collapseNavbar()">
          <span [ngClass]="{ activeSpan: isActive('balance') }">{{ 'global.menu.balance' | translate }}</span>
        </a>
        <a *ngIf="link.title == 'Transaction'" class="dropdown-toggle" uib-dropdown-toggle>
          <span class="transaction">
            <span id="transaction" [ngClass]="{ activeSpan: isActive('fund') || isActive('unitprice') }">{{
              'global.menu.transaction' | translate }}</span>
            <b class="caret"></b>
          </span>
        </a>
        <a *ngIf="link.title == 'Information'" class="dropdown-toggle" uib-dropdown-toggle>
          <span>
            <span id="information" [ngClass]="{ activeSpan: isActive('faq') || isActive('document') }">{{
              'global.menu.information' | translate }}
            </span>
            <b class="caret"></b>
          </span>
        </a>
        <a *ngIf="link.title == 'Contact'" routerLink="contact" routerLinkActive="active" (click)="collapseNavbar()">
          <span [ngClass]="{ activeSpan: isActive('contact') }">{{ 'global.menu.contact' | translate }}</span>
        </a>

        <!-- <a *ngIf="link.title == 'Calculator'" class="dropdown-toggle" uib-dropdown-toggle (click)="collapseNavbar()">
          <span>
            <span id="calculator"  [ngClass]="{ activeSpan: isActive('pensioncalculator') || isActive('pensioncalculatorsetupsetup') }">{{'global.menu.calculator'|translate}} </span>
            <b class="caret"></b>
          </span>
       </a> -->

        <a *ngIf="link.title == 'Calculator'" class="dropdown-toggle" uib-dropdown-toggle id="calculate-menu">
          <span [ngClass]="{ activeSpan: isActive('pensioncalculator') }">{{'global.menu.calculator' |
            translate}}</span>
          <b class="caret"></b>
        </a>

        <a *ngIf="link.title == 'Administration'" class="dropdown-toggle" uib-dropdown-toggle id="admin-menu">
          <span>
            <span
              [ngClass]="{ activeSpan: isActive('fundadmin') || isActive('balance') || isActive('sendwelcomemail') || isActive('sendforgotpassword') ||isActive('userlock') }">{{'global.menu.admin.main'|translate}}</span>
            <b class="caret"></b>
          </span>
        </a>
        <a *ngIf="link.title == 'Account'" class="dropdown-toggle" uib-dropdown-toggle id="account-menu">
          <span [ngClass]="{ activeSpan: isActive('password') }">{{ 'global.menu.accountt' | translate }}</span>
          <b class="caret"></b>
        </a>
        <a *ngIf="link.title == 'Support'" class="dropdown-toggle" uib-dropdown-toggle id="support-menu">
          <span [ngClass]="{ activeSpan: isActive('support') }">{{'global.menu.support.main' | translate}}</span>
          <b class="caret"></b>
        </a>
        <a *ngIf="link.title == 'Risk Profile' && this.isEmployee" routerLink="riskprofile" routerLinkActive="active">
          <span [ngClass]="{ activeSpan: isActive('riskprofile') }">{{ 'global.menu.riskProfile' | translate }}</span>
        </a>
      </li>
    </ul>
  </div>
</nav>

<div class="menublock" *ngFor="let submenu of authenticatedMenus;let i = index;">
  <div *ngIf="submenu.title == 'Transaction'">
    <div *ngIf="app.menu1Opened" id="menu1" class="commonclassDiv">
      <ul class="dropdownall">
        <li [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact: true}">
          <a>
            <span class="dropdown-menu-large-text-title">{{ 'global.menu.transaction' | translate }}</span>
          </a>
        </li>
        <li [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact: true}" (click)="handleLinkClick(1)">
          <a routerLink="fund" routerLinkActive="active">
            <span class="dropdown-menu-large-text">{{ 'global.menu.fund' | translate }}</span>
          </a>
        </li>
        <li [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact: true}" (click)="handleLinkClick(1)">
          <a routerLink="unitprice" routerLinkActive="active">
            <span class="dropdown-menu-large-text">{{ 'global.menu.unit' | translate }}</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
  <div *ngIf="submenu.title == 'Information'">
    <div *ngIf="app.menu2Opened" id="menu2" class="commonclassDiv">
      <ul class="dropdownall">
        <li [routerLinkActive]="['active']">
          <a>
            <span class="dropdown-menu-large-text-title">{{ 'global.menu.information' | translate }}</span>
          </a>
        </li>
        <li [routerLinkActive]="['active']" (click)="handleLinkClick(2)">
          <a routerLink="faq" routerLinkActive="active">
            <span class="dropdown-menu-large-text">FAQ</span>
          </a>
        </li>
        <li [routerLinkActive]="['active']" (click)="handleLinkClick(2)">
          <a routerLink="document" routerLinkActive="active">
            <span class="dropdown-menu-large-text">{{ 'global.menu.document' | translate }}</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
  <div *ngIf="submenu.title == 'Administration'">
    <div *ngIf="app.menu3Opened" id="menu3" class="commonclassDiv">
      <ul class="dropdownall" *ngFor="let submenuChild of submenu.subMenus;let i = index;">
        <li *ngIf="i == 0" [routerLinkActive]="['active']">
          <a>
            <span class="dropdown-menu-large-text-title">{{'global.menu.admin.main'|translate}}</span>
          </a>
        </li>
        <li *ngIf="submenuChild.link == 'fundadmin'" [routerLinkActive]="['active']" (click)="handleLinkClick(3)">
          <a routerLink="fundadmin" routerLinkActive="active">
            <span class="dropdown-menu-large-text">{{'global.menu.addfund'|translate}}
            </span>
          </a>
        </li>
        <li *ngIf="submenuChild.link == 'balance'" [routerLinkActive]="['active']" (click)="handleLinkClick(3)">
          <a routerLink="balance" routerLinkActive="active">
            <span class="dropdown-menu-large-text">{{ 'global.menu.balance' | translate }}</span>
          </a>
        </li>
        <li *ngIf="submenuChild.link == 'sendwelcomemail'" [routerLinkActive]="['active']" (click)="handleLinkClick(3)">
          <a routerLink="sendwelcomemail" routerLinkActive="active">
            <span class="dropdown-menu-large-text">{{'global.menu.resendmail'|translate}}
            </span>
          </a>
        </li>
        <li *ngIf="submenuChild.link == 'sendforgotpassword'" [routerLinkActive]="['active']"
          (click)="handleLinkClick(3)">
          <a routerLink="sendforgotpassword" routerLinkActive="active">
            <span class="dropdown-menu-large-text">{{'global.menu.sendforgot'|translate}}</span>
          </a>
        </li>
        <li *ngIf="submenuChild.link == 'userlock'" [routerLinkActive]="['active']" (click)="handleLinkClick(3)">
          <a routerLink="userlock" routerLinkActive="active">
            <span class="dropdown-menu-large-text">Unlock User</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
  <div *ngIf="submenu.title == 'Account'">
    <div *ngIf="app.menu4Opened" id="menu4" class="commonclassDiv">
      <ul class="dropdownall">
        <li [routerLinkActive]="['active']">
          <a>
            <span class="dropdown-menu-large-text-title">{{ 'global.menu.accountt' | translate }}</span>
          </a>
        </li>
        <li [routerLinkActive]="['active']" (click)="handleLinkClick(4)">
          <a routerLink="password" routerLinkActive="active">
            <span class="dropdown-menu-large-text">{{'global.form.changepassword' | translate}}</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
  <div *ngIf="submenu.title == 'Support'">
    <div *ngIf="app.menu5Opened" id="menu5" class="commonclassDiv">
      <ul class="dropdownall">
        <li [routerLinkActive]="['active']">
          <a>
            <span class="dropdown-menu-large-text-title">Support</span>
          </a>
        </li>
        <li [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact: true}" (click)="handleLinkClick(5)">
          <a routerLink="support/appconfig" routerLinkActive="active">
            <span class="dropdown-menu-large-text">{{'global.menu.support.appconfig' | translate}}</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
  <div *ngIf="submenu.title == 'Calculator'">
    <div *ngIf="app.menu6Opened" id="menu6" class="commonclassDiv">
      <ul class="dropdownall">
        <li [routerLinkActive]="['active']">
          <a>
            <span class="dropdown-menu-large-text-title">Kalkulator</span>
          </a>
        </li>
        <li *ngIf="submenu.subMenus[0] !== undefined" [routerLinkActive]="['active']" (click)="handleLinkClick(6)">
          <a routerLink="calculator/pensioncalculator" routerLinkActive="active">
            <span class="dropdown-menu-large-text">{{ 'global.menu.calculatorm' | translate }}</span>
          </a>
        </li>
        <li *ngIf="submenu.subMenus[1] !== undefined" [routerLinkActive]="['active']" (click)="handleLinkClick(6)">
          <a routerLink="calculator/pensioncalculatorsetup" routerLinkActive="active">
            <span class="dropdown-menu-large-text">{{ 'global.menu.calculators' | translate }}</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</div>